import { doDeleteQuery, doGetQuery, doPostQuery, doPutQuery } from './utils';

export const apiGetTest = async (testUid: string) =>
  await doGetQuery<TTest>(`tests/test/${testUid}`);

export const apiGetTests = async () =>
  await doGetQuery<TTestRich[]>(`tests/list`);

export const apiAddTest = async (test: TTestUpdate): Promise<string> => {
  const { testUid } = await doPostQuery<{ testUid: string }>(
    `tests/test`,
    null,
    { test: { name: test.name } }
  );
  return testUid;
};

export const apiUpdateTest = async (
  testUid: string,
  test: TTestUpdate
): Promise<void> => {
  await doPutQuery<{ testUid: string }>(`tests/test/${testUid}`, null, {
    test: { name: test.name },
  });
};

export const apiDeleteTest = async (testUid: string) =>
  await doDeleteQuery<void>(`tests/test/${testUid}`);
